export const SECOND_PERSON_UNAVAILABLE_VALUE = '2ND_PERSON_NOT_AVAILABLE_(EDUCATE_ON_SAFETY)';
export const PREVIOUS_SECOND_PERSON_UNAVAILABLE_VALUE = '2ND_PERSON_NOT_AVAILABLE_(EDUCATE_OF_SAFETY)';

const valueKey = (value: string) => value.trim().replace(/[^a-z0-9]/gi, '').toLowerCase();

/** Accept the previous Nexus value and display label while existing records/tabs migrate. */
export function canonicalSecondPersonAssistValue(value: string): string {
  const key = valueKey(value);
  return key === valueKey(PREVIOUS_SECOND_PERSON_UNAVAILABLE_VALUE)
    || key === valueKey(SECOND_PERSON_UNAVAILABLE_VALUE)
    ? SECOND_PERSON_UNAVAILABLE_VALUE
    : value;
}

/** The follow-up applies to transfer assistance, not bed mobility or ambulation alone. */
export function requiresSecondPersonAssist(transferStatus: unknown): boolean {
  return valueKey(String(transferStatus ?? '')) === 'assistof2';
}

/** Ignore historical answers when their controlling question no longer applies. */
export function hasUnavailableSecondPerson(data: Record<string, unknown>): boolean {
  return requiresSecondPersonAssist(data.transferStatus)
    && canonicalSecondPersonAssistValue(String(data.secondPersonAssistWhenNeeded ?? '')) === SECOND_PERSON_UNAVAILABLE_VALUE;
}

/** Clear hidden answers on save, including stale submissions from already-open tabs. */
export function nursingMobilityDataForSave(data: Record<string, unknown>): Record<string, unknown> {
  // Partial updates without the controlling field cannot establish applicability.
  if (!Object.prototype.hasOwnProperty.call(data, 'transferStatus') || requiresSecondPersonAssist(data.transferStatus)) return data;
  const next: Record<string, unknown> = { ...data, secondPersonAssistWhenNeeded: null };
  const concerns = data.handOffSafetyConcerns;
  const applicableConcern = (value: unknown) => valueKey(String(value)) !== '2ndpersonnotavailable';
  if (Array.isArray(concerns)) next.handOffSafetyConcerns = concerns.filter(applicableConcern);
  else if (typeof concerns === 'string') next.handOffSafetyConcerns = concerns.split(';').filter(applicableConcern).join(';');
  return next;
}
